'use client';

import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { useAppSelector } from '@/hotdesk-ui/hooks/hook';
import { RootState } from '@/hotdesk-ui/store/store';
import {
    getPreferredUserSubscriptionIds,
    PREFER_USER_SUBSCRIPTION_ID_PARAM
} from '@/hotdesk-ui/utils/subscriptionUtils';

/**
 * Prefer the subscription the user filtered explore with (URL deep-link from
 * the card, else redux filter). Empty → callers fall back to oldest.
 */
export const usePreferredUserSubscriptionIds = (): string[] | undefined => {
    const searchParams = useSearchParams();
    const filterUserSubscriptionIdIn = useAppSelector(
        (state: RootState) => state.listing.filters?.userSubscriptionIdIn
    );

    const preferParam = searchParams.get(PREFER_USER_SUBSCRIPTION_ID_PARAM);

    return useMemo(
        () =>
            getPreferredUserSubscriptionIds(preferParam) ??
            getPreferredUserSubscriptionIds(filterUserSubscriptionIdIn),
        [preferParam, filterUserSubscriptionIdIn]
    );
};
